import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, colors } from '@material-ui/core';
import ShareIcon from '@material-ui/icons/Share';
import { Label } from 'components';
import Table from 'components/Table/Table'
import { GroupRepoDTO, SharedGroupDTO } from 'dto/GroupDTO';

interface GroupsProps {
  className?: string,
  group: GroupRepoDTO,
  sharedGroups: SharedGroupDTO[],
  title?: string,
  onShareRepository?: (shared: boolean, classId: number) => void
}

const Groups = (props: GroupsProps) => {
  const { className, sharedGroups, onShareRepository, title } = props;

  const [open, setOpen] = useState<boolean>(true);

  return (
    <Table
      additionalColumns={[{
        cell: (item) => <Button
          color="primary"
          endIcon={<ShareIcon />}
          onClick={() => {
            onShareRepository && onShareRepository(item.isShared, item.classroomID)
          }}
          size="small"
          variant={item.isShared ? 'outlined' : 'contained'}
        >
          {item.isShared ? 'unshare' : 'share'}
        </Button>,
        header: 'actions',
        id: 'actions',
        cellProps: { align: 'center' },
        headerProps: { align: 'center' }
      }]}
      cellMap={{
        isShared: (item) => <Label color={item.isShared ? colors.green[500] : colors.red[500]}>
          {item.isShared ? 'shared' : 'unshared'}
        </Label>
      }}
      cellProps={{
        isShared: { align: 'center' }
      }}
      classes={{root: className}}
      data={sharedGroups}
      filters={{
        name: {
          type: 'input'
        },
        isShared: {
          type: 'options',
          options: [{
            key: true,
            value: 'Shared'
          }, {
            key: false,
            value: 'Unshared'
          }]
        }
      }}
      headerAlign={{
        isShared: 'center'
      }}
      headerMap={{
        isShared: 'status'
      }}
      headers={['name', 'isShared']}
      idKey='id'
      open={open}
      setOpen={setOpen}
      tableRowProps={(row => ({ selected: row.isShared }))}
      title={title}
    />
  );
};

Groups.propTypes = {
  className: PropTypes.string,
  group: PropTypes.object.isRequired,
  onShareRepository: PropTypes.func,
  sharedGroups: PropTypes.array,
  title: PropTypes.string,
};

Groups.defaultProps = {
  group: {
    allGroups: [],
    repositories: []
  }
};

export default Groups;
